module.exports = __webpack_public_path__ + "static/media/f_5.ebe3a572.jpg";